<template>
<div class="homepage">
  <div class="backdrop"></div>
  <div class="card-container">
    <q-card class="homepage__card col-lg-offset-2">
      <q-card-section>
        <div :class="{'q-mt-md q-mx-md': !$isMobile, 'q-pa-md': $isMobile}">
          <h1 class="heading-2 q-mb-lg text-primary">Handleidingen</h1>
        </div>
        <div class="column q-pt-md" :class="$isMobile ?'q-gutter-y-md' : 'q-gutter-lg'">
          <common-link  v-for="label of Object.keys(manuals)"
                        is-local
                        :label="label"
                       target="_blank"
                       :href="manuals[label]" />
          <flat-button align="left" label="Terug"
                       outline
                       @click="goBack()" />
        </div>
      </q-card-section>
    </q-card>
  </div>
</div>
</template>

<script setup>
import { config } from '~INSTANCE'
import { computed } from 'vue'

const manuals = computed(() => {
  const extraManuals = config.manuals ?? {}

  return {
    ...extraManuals,
    'Handleiding HIOR': '/assets/img/20220177 HIOR uitleg redesign derden.pdf',
  }
})

const goBack = () => {
  window.history.back()
}
</script>
